import React from "react";
export const Store = React.createContext("");

const initialState = {
  results: [],
  aggs: [],
  query: "",
  program: "",
  center: "",
  institutions: "",
  technology: "",
  disease: "",
  licensing: "",
  status: "",
  filter_display : {
      program : false,
      changeHub : true,
      disease : true,
      technology : true,
      status : false,
      institution : true,
      licensing : true,
      searchbar : false
  },
  per_page : 18,
  start_page : 1
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_QUERY":
      state.query = action.payload;
      return { ...state };
    case "SET_PROGRAM":
      state.program = action.payload;
      return { ...state };
    case "SET_CENTER_HUB":
      state.center = action.payload;
      return { ...state };
    case "SET_INSTITUTIONS":
      state.institutions = action.payload;
      return { ...state };
    case "SET_TECHNOLOGY":
      state.technology = action.payload;
      return { ...state };
    case "SET_DISEASE":
      state.disease = action.payload;
      return { ...state };
    case "SET_LICENSING":
      state.licensing = action.payload;
      return { ...state };
    case "SET_STATUS":
      state.status = action.payload;
      return { ...state };
    case "SET_FILTERS_DISPLAY":
        state.filter_display = action.payload;
        return { ...state };      
    case "FETCH_RESULTS":
      state.results = action.payload;
      return { ...state };
    case "FETCH_AGGS":
      state.aggs = action.payload;
      return { ...state };
    case "SET_PER_PAGE":
      state.per_page = action.payload;
      return { ...state };
    case "SET_START_PAGE":
      state.start_page = action.payload;
      return { ...state };
    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
